<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: String,
    default: 'sm',
    validator(value) {
      return ['sm', 'md', 'lg', 'xl', '2xl', 'full'].includes(value);
    },
  },
});

const sizeClass = computed(() => {
  let css;
  switch (props.size) {
    case 'sm':
      css = 'sm:max-w-md';
      break;
    case 'md':
      css = 'sm:max-w-lg';
      break;
    case 'lg':
      css = 'sm:max-w-xl';
      break;
    case 'xl':
      css = 'sm:max-w-2xl';
      break;
    case '2xl':
      css = 'sm:max-w-3xl';
      break;
    default:
      css = null;
  }
  return css;
});
</script>

<template>
  <div
    class="sm:mx-auto sm:w-full"
    :class="sizeClass">
    <slot />
  </div>
</template>
